import React from "react";

export const SalesPoints = ({feature}) => (
    <div id="puntosdeventa" role="tabpanel" className="tab-pane fade in">
        <hr className="visible-xs"/>
        <h3 className="clearmargin hidden-xs">Punto de Venta</h3>
        <div className="general-title margintop20 hidden-xs">Cliente</div>
        <div className="general-title visible-xs">Cliente</div>
        <div className="black brandonMd marginbottom15">
            {feature.socialReason}
        </div>
        <hr className="visible-xs"/>
        <div className="margintop-20"></div>
        <div className="table-responsive">
            <table id="data-table-punto-entrega" className="table table-pedidos table-perfil">
                <thead>
                <tr>
                    <th data-column-id="Id" data-visible="false" data-searchable="false">
                        Id
                    </th>
                    <th data-column-id="NOMBRE">NOMBRE</th>
                    <th data-column-id="DIRECCION">DIRECCIÓN</th>
                    <th data-column-id="LOCALIDAD">LOCALIDAD</th>
                </tr>
                </thead>
                <tbody>
                {feature.deliverySites.map((deliverySite, index) => (
                    <tr key={index}>
                        <td>{deliverySite.Id}</td>
                        <td>{deliverySite.Nombre}</td>
                        <td>{deliverySite.Direccion}</td>
                        <td>{deliverySite.Localidad}</td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    </div>
);